import { reducerSwitch, createReducer } from 'lib/reducerUtils'
import {
  API_CALL_FAILURE,
  API_CALL_REQUEST,
  API_CALL_SUCCESS,
} from 'actions/actionConstants'
import {
  FETCH_CAR_HIRE_OFFERS,
  FETCH_CAR_HIRE_OFFER_IMPORTANT_INFORMATION,
  FETCH_CAR_HIRE_RESERVATION,
}
  from 'actions/apiActionConstants'

export const initialCarHireState: App.CarHireState = {
  offerLists: {},
  reservationInfo: {},
  offerImportantInformationLists: {},
}

const apiRequests = reducerSwitch<App.CarHireState>({
  [FETCH_CAR_HIRE_OFFERS]: (state, action) => ({
    offerLists: {
      ...state.offerLists,
      [action.key]: {
        vehicles: [],
        fetching: true,
        error: undefined,
      },
    },
  }),
  [FETCH_CAR_HIRE_OFFER_IMPORTANT_INFORMATION]: (state, action) => ({
    offerImportantInformationLists: {
      ...state.offerImportantInformationLists,
      [action.key]: {
        data: [],
        fetching: true,
        error: undefined,
      },
    },
  }),
  [FETCH_CAR_HIRE_RESERVATION]: (state, action) => ({
    reservationInfo: {
      ...state.reservationInfo,
      [action.key]: {
        reservation: {},
        fetching: true,
        error: undefined,
      },
    },
  }),
})

const apiSuccesses = reducerSwitch<App.CarHireState>({
  [FETCH_CAR_HIRE_OFFERS]: (state, action) => ({
    offerLists: {
      ...state.offerLists,
      [action.key]: {
        vehicles: action.data,
        fetching: false,
        error: undefined,
      },
    },
    fetchingAvailableVehicles: false,
  }),
  [FETCH_CAR_HIRE_OFFER_IMPORTANT_INFORMATION]: (state, action) => ({
    offerImportantInformationLists: {
      ...state.offerImportantInformationLists,
      [action.key]: {
        data: action.data,
        fetching: false,
        error: undefined,
      },
    },
  }),
  [FETCH_CAR_HIRE_RESERVATION]: (state, action) => ({
    reservationInfo: {
      ...state.reservationInfo,
      [action.key]: {
        reservation: action.data,
        fetching: false,
        error: undefined,
      },
    },
  }),
})

const apiFailures = reducerSwitch<App.CarHireState>({
  [FETCH_CAR_HIRE_OFFERS]: (state, action) => ({
    offerLists: {
      ...state.offerLists,
      [action.key]: {
        vehicles: [],
        fetching: false,
        error: action.error,
      },
    },
  }),
  [FETCH_CAR_HIRE_OFFER_IMPORTANT_INFORMATION]: (state, action) => ({
    offerImportantInformationLists: {
      ...state.offerImportantInformationLists,
      [action.key]: {
        data: [],
        fetching: false,
        error: action.error,
      },
    },
  }),
  [FETCH_CAR_HIRE_RESERVATION]: (state, action) => ({
    reservationInfo: {
      ...state.reservationInfo,
      [action.key]: {
        reservation: {},
        fetching: false,
        error: action.error,
      },
    },
  }),
})

export default createReducer<App.CarHireState>(initialCarHireState, {
  [API_CALL_REQUEST]: (state, action) => apiRequests(action.api)(state, action),
  [API_CALL_FAILURE]: (state, action) => apiFailures(action.api)(state, action),
  [API_CALL_SUCCESS]: (state, action) => apiSuccesses(action.api)(state, action),
})
